import { Model, type ModelProps } from '@/infra/model'
import { WorkspaceBranding } from '@/features/iam/workspaces/workspace-branding'
import { type Id } from '@/infra/id'
import { WorkspaceConfig } from '@/features/iam/workspaces/workspace-config'
import { observable } from 'mobx'

export type WorkspaceArchivalStatus = 'ACTIVE' | 'ARCHIVING' | 'ARCHIVED'

export type WorkspaceProps = ModelProps<Workspace>

/**
 * Workspace classification.
 */
export type WorkspaceClassification =
  | 'B2C'
  | 'B2B'
  | 'B2B2C'
  | 'B2E'
  | 'DEMO'
  | 'TXF'

/**
 * Workspace information.
 */
export class Workspace extends Model<Workspace> {
  static readonly none = new Workspace()

  @observable accessor id: Id
  @observable accessor name = ''
  @observable accessor slug = ''
  @observable accessor classification: WorkspaceClassification = 'B2C'
  @observable accessor branding = WorkspaceBranding.default
  @observable accessor config = WorkspaceConfig.default
  @observable accessor archivalStatus: WorkspaceArchivalStatus = 'ACTIVE'
}
